// Textos de la zona "account". Claves con prefijo "account." (common: sin prefijo fijo).
// Mi perfil, Audios guardados, el reproductor de grabaciones, los textos de
// recordingsApi/tracksApi y los nombres de los países del celular.
const COUNTRY_EN = {
  CO: 'Colombia', VE: 'Venezuela', EC: 'Ecuador', PE: 'Peru', MX: 'Mexico',
  AR: 'Argentina', CL: 'Chile', BO: 'Bolivia', PY: 'Paraguay', UY: 'Uruguay',
  BR: 'Brazil', PA: 'Panama', CR: 'Costa Rica', NI: 'Nicaragua', HN: 'Honduras',
  SV: 'El Salvador', GT: 'Guatemala', CU: 'Cuba', DO: 'Dominican Republic',
  PR: 'Puerto Rico', DE: 'Germany', CA: 'Canada', CN: 'China', ES: 'Spain',
  US: 'United States', FR: 'France', IT: 'Italy', JP: 'Japan', PT: 'Portugal',
  GB: 'United Kingdom',
};
const COUNTRY_ES = {
  CO: 'Colombia', VE: 'Venezuela', EC: 'Ecuador', PE: 'Perú', MX: 'México',
  AR: 'Argentina', CL: 'Chile', BO: 'Bolivia', PY: 'Paraguay', UY: 'Uruguay',
  BR: 'Brasil', PA: 'Panamá', CR: 'Costa Rica', NI: 'Nicaragua', HN: 'Honduras',
  SV: 'El Salvador', GT: 'Guatemala', CU: 'Cuba', DO: 'República Dominicana',
  PR: 'Puerto Rico', DE: 'Alemania', CA: 'Canadá', CN: 'China', ES: 'España',
  US: 'Estados Unidos', FR: 'Francia', IT: 'Italia', JP: 'Japón', PT: 'Portugal',
  GB: 'Reino Unido',
};
const countryKeys = (names) => Object.fromEntries(
  Object.entries(names).map(([iso, name]) => [`account.country.${iso}`, name])
);

const en = {
  // ── Mi perfil ──
  'account.title': 'My profile',
  'account.since': ' · since {date}',
  'account.loading': 'Loading your profile…',
  'account.loadError': 'Could not load your profile. Check your connection.',
  'account.tab.perfil': 'Profile',
  'account.tab.correo': 'Email',
  'account.tab.password': 'Password',
  'account.currentPassword': 'Current password',

  'account.profile.nameRequired': 'Enter your username',
  'account.profile.saved': 'Profile saved.',
  'account.profile.saveError': 'Could not save the profile.',
  'account.profile.username': 'Username',
  'account.profile.usernameHint': 'It’s the one shown at the top right.',
  'account.profile.realName': 'Real name',
  'account.profile.optional': 'Optional',
  'account.profile.phone': 'Mobile',
  'account.profile.phoneHint': 'Without the prefix: just the number.',
  'account.profile.phoneCountry': 'Mobile country',
  'account.profile.listenerQuestion': 'What kind of listener are you?',
  'account.profile.saving': 'Saving…',
  'account.profile.save': 'Save profile',

  'account.listener.experto.label': 'Music expert',
  'account.listener.experto.hint': 'You produce, mix or play. You know what a Q is.',
  'account.listener.melomano.label': 'Music lover',
  'account.listener.melomano.hint': 'Music is your thing and you notice how it sounds.',
  'account.listener.casual.label': 'Casual listener',
  'account.listener.casual.hint': 'You want it to sound good, no fuss.',

  'account.email.requestError': 'Could not request the email change.',
  'account.email.current': 'Current email:',
  'account.email.pendingPre': 'Waiting for you to confirm',
  'account.email.pendingPost': '. Check that inbox (and spam).',
  'account.email.new': 'New email',
  'account.email.newHint': 'We’ll send a link there. Your email changes when you open it.',
  'account.email.sending': 'Sending…',
  'account.email.submit': 'Send confirmation link',

  'account.password.tooShort': 'The new password must be at least {min} characters',
  'account.password.mismatch': 'The two new passwords don’t match',
  'account.password.changeError': 'Could not change the password.',
  'account.password.new': 'New password',
  'account.password.newHint': 'At least {min} characters. Use one you don’t reuse on other sites.',
  'account.password.repeat': 'Repeat the new password',
  'account.password.sessionsNote': 'Changing it signs you out on your other devices. You stay signed in on this one.',
  'account.password.changing': 'Changing…',
  'account.password.submit': 'Change password',

  // ── Audios guardados ──
  'account.saved.title': 'Saved audio',
  'account.saved.loadError': 'Could not load your audio. Check your connection.',
  'account.saved.confirmDelete': 'Delete "{name}"?\n\nIt is removed from the server right now and cannot be recovered.\nIf you want to keep it, close this and press Download first.',
  'account.saved.deleteError': 'Could not delete the audio. Please try again.',
  'account.saved.downloadError': 'Could not download. The audio may have already expired; reload the list.',
  'account.saved.playError': 'Could not prepare playback. The audio may have already expired.',
  'account.saved.renameError': 'Could not rename it. Please try again.',
  'account.saved.count': '{n} of {max} audio files',
  'account.saved.usage': '{used} of {quota} MB',
  'account.saved.empty': 'You haven’t saved any audio yet.',
  'account.saved.emptyHint1': 'Put the',
  'account.saved.emptyRecorder': 'Recorder',
  'account.saved.emptyHint2': 'effect in any processor slot, record, and press',
  'account.saved.emptySave': 'Save to my account',
  'account.saved.mono': 'mono',
  'account.saved.stereo': 'stereo',
  'account.saved.aboutToDelete': 'About to be deleted',
  'account.saved.deletesIn': 'Deleted in {time}',
  'account.saved.renameInput': 'New audio name',
  'account.saved.saveName': 'Save the new name',
  'account.saved.cancelRename': 'Cancel renaming',
  'account.saved.closePlayer': 'Close the player',
  'account.saved.closePlayerOf': 'Close the player for {name}',
  'account.saved.listen': 'Listen',
  'account.saved.listenTo': 'Listen to {name}',
  'account.saved.rename': 'Rename',
  'account.saved.renameOf': 'Rename {name}',
  'account.saved.downloadTitle': 'Download to this device',
  'account.saved.download': 'Download',
  'account.saved.deleteNow': 'Delete now',
  'account.saved.deleteOf': 'Delete {name}',
  'account.saved.footer': 'Audio is deleted automatically {hours} hours after saving. Download what you want to keep: once deleted it cannot be recovered.',

  // ── Reproductor de grabaciones ──
  'account.player.cantPlayHere': 'This audio can’t be played here',
  'account.player.pause': 'Pause',
  'account.player.play': 'Listen',
  'account.player.unsupported': 'This browser can’t play the file. Download it to listen.',
  'account.player.position': 'Playback position',
  'account.player.seekHint': 'Click or drag to move through the audio',

  // ── Cuenta regresiva (recordingsApi / tracksApi) ──
  'account.time.expiring': 'expiring…',
  'account.time.hm': '{h} h {m} min',
  'account.time.m': '{m} min',
  'account.time.h': '{h} h',
  'account.time.days': ({ n }) => `${n} day${n === 1 ? '' : 's'}`,

  // ── Errores al subir pistas (tracksApi) ──
  'account.tracks.noResponse': 'No response from the server. It may be your connection, or the server may be down right now.',
  'account.tracks.sessionExpired': 'Your session expired. Sign in again to save tracks.',
  'account.tracks.noRoute': 'The server doesn’t recognize the /tracks route. Its `handle` is missing in the Caddyfile (see DESPLIEGUE_AWS.md).',
  'account.tracks.tooLarge': 'The file is too large (max {mb} MB). If it’s a WAV, convert it to MP3 and it will fit easily.',
  'account.tracks.serverDown': 'The app server didn’t respond. It may be down or restarting.',
  'account.tracks.saveError': 'Could not save the track (error {status}).',

  ...countryKeys(COUNTRY_EN),
};

const es = {
  'account.title': 'Mi perfil',
  'account.since': ' · desde {date}',
  'account.loading': 'Cargando tu perfil…',
  'account.loadError': 'No se pudo cargar tu perfil. Revisa tu conexión.',
  'account.tab.perfil': 'Perfil',
  'account.tab.correo': 'Correo',
  'account.tab.password': 'Contraseña',
  'account.currentPassword': 'Contraseña actual',

  'account.profile.nameRequired': 'Escribe tu nombre de usuario',
  'account.profile.saved': 'Perfil guardado.',
  'account.profile.saveError': 'No se pudo guardar el perfil.',
  'account.profile.username': 'Nombre de usuario',
  'account.profile.usernameHint': 'Es el que sale arriba a la derecha.',
  'account.profile.realName': 'Nombre real',
  'account.profile.optional': 'Opcional',
  'account.profile.phone': 'Celular',
  'account.profile.phoneHint': 'Sin el prefijo: solo el número.',
  'account.profile.phoneCountry': 'País del celular',
  'account.profile.listenerQuestion': '¿Qué tipo de oyente eres?',
  'account.profile.saving': 'Guardando…',
  'account.profile.save': 'Guardar perfil',

  'account.listener.experto.label': 'Experto en música',
  'account.listener.experto.hint': 'Produces, mezclas o tocas. Sabes lo que es un Q.',
  'account.listener.melomano.label': 'Melómano',
  'account.listener.melomano.hint': 'La música es lo tuyo y te fijas en cómo suena.',
  'account.listener.casual.label': 'Oyente casual',
  'account.listener.casual.hint': 'Quieres que suene bien, sin complicarte.',

  'account.email.requestError': 'No se pudo pedir el cambio de correo.',
  'account.email.current': 'Correo actual:',
  'account.email.pendingPre': 'Esperando que confirmes',
  'account.email.pendingPost': '. Revisa ese buzón (y el spam).',
  'account.email.new': 'Correo nuevo',
  'account.email.newHint': 'Te mandaremos un enlace ahí. Tu correo cambia cuando lo abras.',
  'account.email.sending': 'Enviando…',
  'account.email.submit': 'Enviar enlace de confirmación',

  'account.password.tooShort': 'La contraseña nueva debe tener al menos {min} caracteres',
  'account.password.mismatch': 'Las dos contraseñas nuevas no coinciden',
  'account.password.changeError': 'No se pudo cambiar la contraseña.',
  'account.password.new': 'Contraseña nueva',
  'account.password.newHint': 'Mínimo {min} caracteres. Usa una que no repitas en otras páginas.',
  'account.password.repeat': 'Repite la contraseña nueva',
  'account.password.sessionsNote': 'Al cambiarla se cierra tu sesión en los demás dispositivos. En este sigues dentro.',
  'account.password.changing': 'Cambiando…',
  'account.password.submit': 'Cambiar contraseña',

  'account.saved.title': 'Audios guardados',
  'account.saved.loadError': 'No se pudieron cargar tus audios. Revisa tu conexión.',
  'account.saved.confirmDelete': '¿Borrar "{name}"?\n\nSe elimina del servidor ahora mismo y no se puede recuperar.\nSi lo quieres conservar, ciérralo y pulsa Descargar primero.',
  'account.saved.deleteError': 'No se pudo borrar el audio. Inténtalo otra vez.',
  'account.saved.downloadError': 'No se pudo descargar. Puede que el audio ya haya vencido; recarga la lista.',
  'account.saved.playError': 'No se pudo preparar la reproducción. Puede que el audio ya haya vencido.',
  'account.saved.renameError': 'No se pudo cambiar el nombre. Inténtalo otra vez.',
  'account.saved.count': '{n} de {max} audios',
  'account.saved.usage': '{used} de {quota} MB',
  'account.saved.empty': 'Todavía no has guardado ningún audio.',
  'account.saved.emptyHint1': 'Pon el efecto',
  'account.saved.emptyRecorder': 'Grabadora',
  'account.saved.emptyHint2': 'en cualquier slot del procesador, graba, y pulsa',
  'account.saved.emptySave': 'Guardar en mi cuenta',
  'account.saved.mono': 'mono',
  'account.saved.stereo': 'estéreo',
  'account.saved.aboutToDelete': 'A punto de borrarse',
  'account.saved.deletesIn': 'Se borra en {time}',
  'account.saved.renameInput': 'Nuevo nombre del audio',
  'account.saved.saveName': 'Guardar el nombre nuevo',
  'account.saved.cancelRename': 'Cancelar el cambio de nombre',
  'account.saved.closePlayer': 'Cerrar el reproductor',
  'account.saved.closePlayerOf': 'Cerrar el reproductor de {name}',
  'account.saved.listen': 'Escuchar',
  'account.saved.listenTo': 'Escuchar {name}',
  'account.saved.rename': 'Cambiar el nombre',
  'account.saved.renameOf': 'Cambiar el nombre de {name}',
  'account.saved.downloadTitle': 'Descargar a este equipo',
  'account.saved.download': 'Descargar',
  'account.saved.deleteNow': 'Borrar ahora',
  'account.saved.deleteOf': 'Borrar {name}',
  'account.saved.footer': 'Los audios se borran solos {hours} horas después de guardarlos. Descarga los que quieras conservar: una vez borrados no se pueden recuperar.',

  'account.player.cantPlayHere': 'Este audio no se puede reproducir aquí',
  'account.player.pause': 'Pausar',
  'account.player.play': 'Escuchar',
  'account.player.unsupported': 'Este navegador no puede reproducir el archivo. Descárgalo para escucharlo.',
  'account.player.position': 'Posición de reproducción',
  'account.player.seekHint': 'Pulsa o arrastra para moverte por el audio',

  'account.time.expiring': 'venciendo…',
  'account.time.hm': '{h} h {m} min',
  'account.time.m': '{m} min',
  'account.time.h': '{h} h',
  'account.time.days': ({ n }) => `${n} día${n === 1 ? '' : 's'}`,

  'account.tracks.noResponse': 'No hubo respuesta del servidor. Puede ser tu conexión, o que el servidor no esté funcionando ahora mismo.',
  'account.tracks.sessionExpired': 'Tu sesión venció. Vuelve a iniciar sesión para guardar pistas.',
  'account.tracks.noRoute': 'El servidor no reconoce la ruta /tracks. Falta su `handle` en el Caddyfile (ver DESPLIEGUE_AWS.md).',
  'account.tracks.tooLarge': 'El archivo es demasiado grande (máximo {mb} MB). Si es un WAV, conviértelo a MP3 y cabrá de sobra.',
  'account.tracks.serverDown': 'El servidor de la app no respondió. Puede estar caído o reiniciándose.',
  'account.tracks.saveError': 'No se pudo guardar la pista (error {status}).',

  ...countryKeys(COUNTRY_ES),
};

const account = { en, es };
export default account;
